import React from "react";
import "../style/Footer.css";
import logo from "../images/logo_name.png";
import { LuHeart, LuMail, LuPhone, LuInstagram, LuFacebook } from "react-icons/lu";

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo-wrap">
            <img src={logo} alt="Rammyaa logo" className="footer-logo" />
          </div>
          <p className="footer-tagline">
            Care Beyond Beauty <LuHeart className="footer-tagline-icon" />
          </p>
          <p className="footer-description">
            Naturally powered haircare crafted with Arnica, gentle on your
            scalp, serious about healthy, strong and beautiful hair.
          </p>
        </div>
        <div className="footer-column">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-list">
            <li>
              <a href="#home">Home</a>
            </li>
            <li>
              <a href="#products">Products</a>
            </li>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4 className="footer-heading">Get in Touch</h4>
          <ul className="footer-list">
            <li className="footer-list-item">
              <LuMail size="1em" className="footer-list-icon" />
              <a href="mailto:rammyaa05@gmail.com">rammyaa05@gmail.com</a>
            </li>
            <li className="footer-list-item">
              <LuPhone size="1em" className="footer-list-icon" />
              <a href="tel:+919717140480">9717140480</a>
            </li>
          </ul>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/_.rammyaa"
              aria-label="Rammyaa on Instagram"
              className="footer-social-link"
            >
              <LuInstagram size="1em" />
            </a>
            <a
              href="https://www.facebook.com/share/1EVytxXTEZ/"
              aria-label="Rammyaa on Facebook"
              className="footer-social-link"
            >
              <LuFacebook size="1em" />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © 2026 Rammyaa. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
